import * as authSelectors from '@redux/reducers/auth';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Spinner, Tooltip } from 'reactstrap';
import Icon from 'utility/icomoon';

interface Props {
  id?: string;
  icon?: string;
  // Icono como imagen (p.ej. avatar de Webi para acciones de IA). Tiene
  // prioridad sobre `icon` cuando se provee.
  iconImage?: string;
  // Icono como nodo React (p.ej. FontAwesome). Máxima prioridad. Útil para
  // normalizar acciones de IA con el icono de Webi (faUserAstronaut).
  iconNode?: React.ReactNode;
  permissions?: any[];
  isDisabled?: boolean;
  handleClick: any;
  className?: string;
  tooltipMessage?: any;
  tooltipMessageDisabled?: any;
  visible?: boolean;
  color?: string;
  iconSize?: number;
  isLoading?: boolean;
  tooltipPosition?: string;
  styles?: any;
  children?: React.ReactNode;
  // Color propio del icono, para logos de marca que no deben heredar el color
  // del botón (por defecto `currentColor`).
  iconColor?: string;
}

const DefaultButton = (props: Props) => {
  const store = useSelector((state) => state);
  const {
    isDisabled = false,
    isLoading = false,
    handleClick,
    tooltipMessage,
    tooltipMessageDisabled,
    icon = 'Plus',
    iconImage,
    iconNode,
    id = 'DefaultButton',
    permissions,
    color,
    className = '',
    iconSize = 16,
    visible = true,
    tooltipPosition = 'top',
    children,
    iconColor
  } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  // Determinar qué mensaje de tooltip mostrar
  const currentTooltipMessage = isDisabled ? tooltipMessageDisabled : tooltipMessage;

  return (!permissions || authSelectors.getAuthUserHasPermissionsAny(store, permissions)) &&
    visible ? (
    <Button.Ripple
      id={id}
      className={`${children ? '' : 'btn-icon'} ${isDisabled ? 'disabled' : ''} ${className}`}
      color={color ?? 'secondary'}
      disabled={isDisabled}
      onClick={handleClick}
      style={props.styles}
    >
      {isLoading ? (
        <>
          <Spinner as="span" animation="border" size={'sm'} role="status" aria-hidden="true" />
          {children && <span className="ml-1">{children}</span>}
        </>
      ) : (
        <>
          {iconNode ? (
            iconNode
          ) : iconImage ? (
            <img
              src={iconImage}
              alt=""
              style={{ width: iconSize, height: iconSize, objectFit: 'contain' }}
            />
          ) : (
            <Icon size={iconSize} icon={icon} color={iconColor} />
          )}
          {children && <span className="ml-1">{children}</span>}
        </>
      )}

      {currentTooltipMessage && (
        <Tooltip
          placement={tooltipPosition}
          isOpen={tooltipOpen}
          target={id}
          toggle={toggle}
          trigger="click hover"
        >
          {currentTooltipMessage}
        </Tooltip>
      )}
    </Button.Ripple>
  ) : null;
};

export default DefaultButton;
